import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from '../../../app.component';
import { FormsModule } from '@angular/forms';
import { SplashComponent } from '../../components/splash/splash.component';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { ConnectionService } from '../../services/Connection/connection.service';
import { UserDataComponent } from '../../../views/user-data/user-data.component';
import { PedidosComponent } from '../../../views/pedidos/pedidos.component';
import { ConsumptionComponent } from '../../../views/consumption/consumption.component';
import {OrderConfirmationComponent } from '../../../views/order-confirmation/order-confirmation.component';
import { OrderDetailsComponent } from '../../../views/order-details/order-details.component';
import { CartComponent } from '../../../views/cart/cart.component';
import { AddressComponent } from '../../../views/address/address.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { LoadingProcessingOrderComponent } from '../../components/loading-processing-order/loading-processing-order/loading-processing-order.component';
import { OrderConfirmationCounterComponent } from '../../../views/orderConfirmationCounter/order-confirmation-counter.component';
import { MenuComponent } from '../../../views/menu/menu.component';
import { ProductDetailComponent } from '../../../views/product-detail/product-detail.component';
import { EditProductComponent } from '../../../views/edit-product/edit-product.component';
import { UserViewComponent } from '../../../views/user-view/user-view.component';
import { FidelityComponent } from '../../../views/fidelity/fidelity.component';
import { CouponsComponent } from '../../../views/coupons/coupons.component';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import localePt from '@angular/common/locales/pt';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../layout/layout.module';
import { HistoryCashbackComponent } from 'src/app/views/history-cashback/history-cashback.component';
import { QRCodeComponent } from 'angularx-qrcode';

const components = [
  AppComponent,
  UserDataComponent,
  ConsumptionComponent,
  OrderConfirmationComponent,
  PedidosComponent,
  OrderDetailsComponent,
  CartComponent,
  MenuComponent,
  AddressComponent,
  LoadingProcessingOrderComponent,
  OrderConfirmationCounterComponent, 
  ProductDetailComponent,
  EditProductComponent,
  UserViewComponent,
  FidelityComponent,
  CouponsComponent,
  HistoryCashbackComponent
]

registerLocaleData(localePt);

@NgModule({
  declarations: components,
  imports: [
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientJsonpModule,
    NgScrollbarModule,
    SlickCarouselModule,
    MatRadioModule,
    RouterModule,
    SharedModule,
    LayoutModule,
    QRCodeComponent
],
  exports: components,
  providers: [
    ConnectionService,
    SplashComponent,
    CurrencyPipe,
    DatePipe,
    MenuComponent,
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
